<template>
    <div class="uploadbox">
        
        <div class="upload" element-loading-text="正在分析.. 预计等待1分钟" >
            <div class="imglist">
                <div class="imgitem" v-for="(item, i) in filelist" :key="item">
                    <img src="../../assets/img/znt/upload/icon.png" alt="" srcset="">
                    <div class="imgtitle">{{item.file.name}}</div>
                    <div class="ylbtn" @click="openwindow(item.data)">预览</div>
                    <div class="delbtn" @click="delitem(i)"><i class="el-icon-delete"></i></div>
                </div>
            </div>
            <div class="additem" @click="triggerUpload">
                <img src="../../assets/img/znt/upload/bg.png" alt="">
                <div class="tip">上传图片</div>
                <div class="stip">支持 JPG、PNG 格式，最多上传1张</div>
            </div>
            <input type="file" style="display: none" ref="fxfileInput" @change="handleFileChange" />
            <!-- <div class="address">
                选择位置：<el-radio-group v-model="address" size="small">
                  <el-radio-button label="4"></el-radio-button>
                  <el-radio-button label="7" ></el-radio-button>
                  <el-radio-button label="8"></el-radio-button>
                  <el-radio-button label="10"></el-radio-button>
                  <el-radio-button label="13"></el-radio-button>
                  <el-radio-button label="15"></el-radio-button>
                </el-radio-group>
              </div> -->
            <div class="addbtn" @click="startfx">开始分析</div>
        </div>
        <div class="detail" v-if="report['cause']">
            <!-- <div class="backbtn"><el-button type="text" icon="el-icon-back">返回</el-button></div> -->
            <div class="infobox">
                <div class="logo"> <img src="../../assets/img/znt/upload/logo.gif" alt=""></div>
                <div class="txtbox">{{ report['raw_prediction'] }}</div>
            </div>
            <div class="infobox info1">
                <div class="title">病虫害可能的原因是什么？</div>
                <div class="txtbox">
                    <div class="fkitem">
                        <div  class="fitemcontent l1">{{report['cause'] || '暂无'}}</div>
                    </div>
                </div>
            </div>
            <div class="infobox info1 info2">
                <div class="title">如何预防此类病虫害</div>
                <div class="txtbox">
                    <div class="fkitem">
                        <div class="fitemcontent l2">{{report['prevention'] || '暂无'}}</div>
                    </div>
                </div>
            </div>
            <div class="infobox info1 info2">
                <div class="title">如何治疗此类病虫害</div>
                <div class="txtbox">
                    <div class="fkitem">
                        <div class="fitemcontent l3">{{report['treatment'] || '暂无'}}</div>
                    </div>
                </div>
            </div>
            <div class="infobox info1 info3">
                <div class="title">重要提示</div>
                <div class="txtbox">
                    <div class="fkitem">
                        <div class="fitemcontent l1">{{report['alert'] || '暂无'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="图片预览" :visible.sync="imgflag" :modal-append-to-body="false" width="90%" 
        :before-close="handleClose">
            <img :src="imgurl" style="width:100%" />
        </el-dialog>
    </div>

</template>

<script>
import {getreport} from '@/api/bot'
import { baseUrl } from '@/axios/baseUrl'
export default {
    name: 'index',
    components: {  },
    data() {
        return {
            address: 4,
            filelist: [],
            uploading: false,
            imgflag: false,
            imgurl: '',
            files: [],
            report: []
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        startfx() {
            const loading = this.$loading({
                lock: true,
                text: '正在分析，预计等待1分钟',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const xhr = new XMLHttpRequest();
            const formdata = new FormData();
            const imgs = []
            this.filelist.forEach(item => {
                formdata.append('file', item.file)
            })
            formdata.append('question', '')
            // xhr.open('POST', 'http://113.194.88.168:20292/predict');
            xhr.open('POST', baseUrl + '/bchapi/predict_split');
            xhr.timeout = 1000 * 60 * 10;
            xhr.send(formdata);
            xhr.onreadystatechange = () => {
                console.log(xhr.readyState, xhr.status)
                if (xhr.readyState != 4) return
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const res = JSON.parse(xhr.responseText);
                    if (!res.success) {
                        this.$message.error('分析失败，请更换具体病虫害的特写照片')
                    }
                    loading.close();
                    console.log('report', res)
                    this.report = res
                } else {
                    this.$message.error('分析失败，请稍候再试')
                    loading.close();
                }
            }
        },
        handleClose() {
            this.imgflag = false
        },
        openwindow(e) {
            console.log(e)
            this.imgflag = true
            this.imgurl = e
        },
        delitem(i) {
            console.log("要删除的下标：", i);
            // 直接修改原数组，删除下标为i的元素（删除1个）
            this.filelist.splice(i, 1); 
            this.report = []
            // 无需重新赋值，splice已直接修改原数组
            console.log("删除后的数组：", this.filelist);
        },
        triggerUpload() {
            this.$refs.fxfileInput.click(); // 触发input的点击事件
        },
        handleFileChange(event) {
            this.uploading = true;
            const file = event.target.files[0]; // 获取选中的文件
            this.files.push(file)
            
            if (file) {
                this.filelist.push({
                    data: '',
                    file: file
                })
                const reader = new FileReader();
                
                // 文件读取完成后的回调
                reader.onload = (e) => {
                    this.filelist.filter(item => item.file.name == file.name)[0].data = e.target.result; // 设置图片源为 DataURL
                };
                this.uploading = false;
                // 读取文件为 DataURL 格式
                reader.readAsDataURL(file);
                console.log('first', this.filelist)
            }
        },
        deleteKey(obj, keyToDelete) {
            // 创建一个新对象，避免修改原对象
            const newObj = { ...obj };
            
            // 遍历对象的所有键
            for (const key in newObj) {
                if (newObj.hasOwnProperty(key)) {
                // 支持正则匹配或精确匹配
                const isMatch = key === keyToDelete || 
                    (keyToDelete instanceof RegExp && keyToDelete.test(key));
                
                if (isMatch) {
                    delete newObj[key]; // 删除匹配的键
                }
                }
            }
            
            return newObj;
        }
    }
}




</script>

<style scoped lang="less">
.uploadbox {
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
    .imglist{
        width: 100%;
        padding-top: 15px;
        .imgitem{
            width: 100%;
            background-color: #FFFFFF;
            height: 40px;
            border-radius: 10px;
            display: flex;
            font-size: 14px;
            align-items: center;
            padding: 0 10px;
            color: #00000090;
            margin-bottom: 10px;
            img{
                width: 20px;
                margin-right: 10px;
            }
            .imgtitle{
                width: calc(100% - 90px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .ylbtn{
                color: #6DAF0F;
                margin-right: 10px;
            }
        }
    }
    .additem{
            background-color: #ffffffba;
            width: 100%;
            text-align: center;
            padding: 20px 0;
            border-radius: 10px;
            img{
                width: 100px;
            }
            .tip{
                font-size: 16px;
                color: #333;
                margin: 10px 0;
            }
            .stip{
                font-size: 14px;
                color: #33333380;
            }
    }
    .address{
        margin-top: 20px;text-align: center;
        font-size: 14px;
        color: #333;
    }
    .addbtn{
        width: 100%;
        background-color: #699b23;
        color: #fff;
        height: 40px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        font-size: 16px;
    }

    .detail{
        width: 100%;
        height: 100%;
        position: relative;
        .backbtn{
            position: absolute;
            right: 10px;
            top: -20px;
        }
        .infobox{
            display: flex;
            flex-wrap: wrap;
            background-color: #ffffff;
            border-radius: 10px;
            padding: 10px;
            margin: 10px 0;
            .logo{
                width: 100px;
                img{
                    width: 100px;
                }
            }
            .txtbox{
                width: calc(100% - 100px);
                font-size: 14px;
                line-height: 22px;
                color: #333;
            }
            .title{
                width: 100%;
                font-size: 16px;
                color: #000000d9;
                margin: 10px;
                margin-bottom: 0;
                font-weight: bold;
            }
        }
        .info1{
            background-color: #F0FDF4;
            .txtbox{
                width: 100%;
                margin: 10px 0;
                .fkitem{
                    border-radius: 8px;
                    background-color: #fff;
                    width: 100%;
                    padding: 20px;
                    margin: 10px 0;
                    .fitemtitle{
                        font-size: 14px;
                        display: flex;
                        img{
                            width: 18px;
                            margin-right: 10px;
                        }
                    }
                    .fitemcontent{
                        font-size: 14px;
                        margin-top: 10px;
                    }
                    .l1{
                        color: #DE5F5F;
                    }
                    .l2{
                        color: #1B8A3A;
                    }
                    .l3{
                        color: #446BC2;
                    }
                }
            }
        }
        .info2, .info3{
            background-color: #EFF6FF;
            .txtbox{
                width: 100%;
                margin: 10px 0;
                .fkitem{
                    background-color: #fff;
                    border-radius: 8px;
                    width: 100%;
                    padding: 20px;
                    margin: 10px 0;
                    color: #1B8A3A;
                    .fitemtitle{
                        font-size: 14px;
                    }
                    .fitemcontent{
                        font-size: 14px;
                        margin-top: 10px;
                    }
                }
            }
        }
        .info3{
            background-color: #F0EFFF;
            .txtbox{
                width: 100%;
                margin: 10px 0;
                .fkitem{
                    color: #00000090;
                    .fitemtitle{
                        color: #333;
                        display: flex;
                        img{
                            width: 18px;
                            margin-right: 10px;
                        }
                    }
                }
            }
            
        }
    }
}
/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FFF;
    background-color: #699b23;
    border-color: #699b23;
    box-shadow: -1px 0 0 0 #699b23;
}
</style>
